import React, { useState, useEffect } from 'react';
import { HiOutlineBell, HiXMark } from 'react-icons/hi2';
import './GlobalNotification.css';

const GlobalNotification = () => {
  const [notification, setNotification] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Function to check for new notifications
    const checkForNotification = () => {
      const saved = localStorage.getItem('stocks4u_global_notification');
      if (saved) {
        const data = JSON.parse(saved);
        const now = new Date().getTime();
        const dismissed = localStorage.getItem(`dismissed_notif_${data.id}`);
        
        // Use data.expiry if available, otherwise fallback to 24h
        const expiryTime = data.expiry || (data.timestamp + 86400000);
        
        if (now < expiryTime && !dismissed) {
          setNotification(data);
          setIsVisible(true);
        } else {
          setIsVisible(false);
        }
      } else {
        setNotification(null);
        setIsVisible(false);
      }
    };

    // Initial check
    checkForNotification();

    // Listen for storage changes (works across tabs)
    const handleStorageChange = (e) => {
      if (e.key === 'stocks4u_global_notification') {
        checkForNotification();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    
    // Check every few seconds for local tab changes
    const interval = setInterval(checkForNotification, 3000);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    if (notification) {
      localStorage.setItem(`dismissed_notif_${notification.id}`, 'true');
    }
  };

  if (!isVisible || !notification) return null;

  return (
    <div className="global-notif-wrapper">
      <div className="global-notif-card">
        <div className="notif-icon-pulse">
          <HiOutlineBell />
        </div>
        <div className="notif-content">
          <div className="notif-header">
            <span className="notif-badge">BROADCAST</span>
            <span className="notif-time">Just now</span>
          </div>
          <p className="notif-message">{notification.message}</p>
        </div>
        <button className="notif-close-btn" onClick={handleDismiss}>
          <HiXMark />
        </button>
      </div>
    </div>
  );
};

export default GlobalNotification;
